// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"5e30b9c7","348":"85fb527f","571":"7334eb14","924":"19980755"}[chunkId] + ".chunk.js";
};